import { render, staticRenderFns } from "./PayoutDetailsListItem.vue?vue&type=template&id=480490ee&"
import script from "./PayoutDetailsListItem.vue?vue&type=script&lang=js&"
export * from "./PayoutDetailsListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports